import { Group } from "@visx/group";
import React, { useContext } from "react";
import { Bars } from "../components/Bars";
import { ChartTooltipContext } from "../components/ChartTooltip";
import type { DataPoint } from "../types";
import { XYChartTooltip } from "./XYChartTooltip";
import type { XYChartBarsProps } from "./types";

const XYChartBars = ({
  bottomAccessor,
  hasLines,
  bottomAxis,
  leftAxis,
  rightAxis,
  ...commonChartProps
}: XYChartBarsProps) => {
  const { showTooltip, hideTooltip, containerBounds } =
    useContext(ChartTooltipContext);

  const onBarPointerMove = (
    event: MouseEvent,
    point: DataPoint,
    axis: "left" | "right"
  ) => {
    if (point && !hasLines && showTooltip) {
      const x = ("clientX" in event ? event.clientX : 0) - containerBounds.x;

      const y = ("clientY" in event ? event.clientY : 0) - containerBounds.y;

      const axisObject = axis === "left" ? leftAxis : rightAxis;

      const value = axisObject?.valueRenderer
        ? axisObject?.valueRenderer(point)
        : axisObject?.valueAccessor(point);

      showTooltip({
        tooltipLeft: x,
        tooltipTop: y,
        component: (
          <XYChartTooltip
            items={[
              {
                value,
                variant: "bar",
                label: bottomAxis.tickRenderer(bottomAccessor(point)),
              },
            ]}
          />
        ),
      });
    }
  };

  const onMouseLeave = () => {
    if (hideTooltip) {
      hideTooltip();
    }
  };

  return (
    <Group>
      <Bars
        {...(commonChartProps as any)}
        onPointerMove={(event, point) =>
          onBarPointerMove(event, point, point.axis)
        }
        onMouseLeave={onMouseLeave}
      />
    </Group>
  );
};

export default XYChartBars;
